import rfdc from 'rfdc';
import { v4 } from 'uuid';

export function uuid() {
    return v4();
}

export function cloneDeep<T = any>(obj: T): T {
    return rfdc()(obj);
}

export function toYesNo(value: any) {
    return value ? 'Yes' : 'No';
}
